import { render, staticRenderFns } from "./change-log.vue?vue&type=template&id=6b0de23e&"
import script from "./change-log.vue?vue&type=script&lang=js&"
export * from "./change-log.vue?vue&type=script&lang=js&"
import style0 from "./change-log.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports